import axios from 'axios'

export const DASHBOARD_URL = `${process.env.REACT_APP_API_URL}/Dashboard`

export interface DashboardMetrics {
  profilesCreated: number
  submittedApplications: number
  completionRate: number
  draftCount: number
  completedCount: number
  submissionErrors: number
  otpFailures: number
  incompleteSteps: number
}

export function getDashboardMetrics(from: string, to: string) {
  return axios.get<DashboardMetrics>(`${DASHBOARD_URL}/metrics`, {
    params: {from, to},
  })
}
